import React from 'react';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Icon from './Icon';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import WideImage from './WideImage';

interface InfoSquarePropsBase {
  label: string;
  subLabel?: string;
  variant?: 'default' | 'green' | 'red';
  iconStyle?: React.CSSProperties;
}

interface InfoSquarePropsImageBase {
  image?: string;
  type: 'image';
}

interface InfoSquarePropsIconBase {
  icon: IconProp;
  type?: 'icon';
}

type InfoSquareProps = InfoSquarePropsBase &
  (InfoSquarePropsImageBase | InfoSquarePropsIconBase) &
  React.HTMLAttributes<HTMLDivElement>;

export default function InfoSquare(props: InfoSquareProps) {
  const {
    className: propClasses,
    iconStyle: propIconStyle,
    type,
    label,
    subLabel,
    variant,
    ...rest
  } = props;

  // necessary to prevent invalid HTML attributes from being passed to the div
  delete (rest as any).type;
  delete (rest as any).icon;
  delete (rest as any).image;

  const classes = ['flex items-center gap-4'];
  if (propClasses) classes.push(propClasses);
  classes.push('go-info-square');

  const iconClasses = [
    'self-start grid items-center justify-center text-center text-lg rounded-lg',
  ];
  if (variant === 'green') {
    iconClasses.push('bg-green-100 text-green-600');
  } else if (variant === 'red') {
    iconClasses.push('bg-red-100 text-red-600');
  } else {
    iconClasses.push('bg-highlight');
  }
  iconClasses.push('go-icon-square');

  const textClasses = ['go-icon-text'];

  return (
    <div {...rest} className={classes.join(' ')}>
      {(!type || type === 'icon') && (
        <div className={iconClasses.join(' ')}>
          <Icon icon={props.icon} />
        </div>
      )}
      {type === 'image' && (
        <div style={{ width: 100, flexShrink: 0 }}>
          <WideImage image={props.image} title={label} />
        </div>
      )}
      <div className={textClasses.join(' ')}>
        <div className="font-bold">{label}</div>
        {subLabel && (
          <div
            className="text-secondary html-view"
            dangerouslySetInnerHTML={{ __html: subLabel }}
          ></div>
        )}
      </div>
    </div>
  );
}
